import React, { useEffect, useState, useRef } from 'react';
import { Card } from './ui/Card';
const BONUS_ITEMS = [{
  img: 'https://cdn.magicpatterns.com/uploads/q4NrZBRmnMoiApZxdRrbqm/1-bono-1-masterclass-electricidad-y-sist_pSXtUiEbQXWmz3ZKkWJnMg_xt42s8eGT4y5T4d745wQEQ_hd.png',
  title: 'BONUS #1: La Biblia del Maestro Mecánico',
  desc: 'Manual técnico de consulta rápida.',
  price: '$14.990'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/dfEDjVGJrHSHdi25jjRyxU/a-photorealistic-product-photograph-base_KJExYIC7T7ezSQAcBnxoCA_KpTGN4p-TgiDTGFU-s-_KA_hd.png',
  title: 'BONUS #2: Curso de Electricidad Avanzada',
  desc: 'Dominá el uso del tester y circuitos.',
  price: '$18.500'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/6iLqHaLaJD9GK2sYPz9LY8/3-bono-3-ingenieria-en-frio-refrigeracio_cmPLItUmTsK4VNRw71s3JA_wkrRncOAT5KUmW_FZLFrNg_hd.png',
  title: 'BONUS #3: Guía de Gestión y Presupuesto',
  desc: 'Aprendé a valorar tu trabajo.',
  price: '$12.000'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/1aTFc4wVgU8naKyGdRLaad/4-bono-4-manual-del-diagnosticador-resol_S0yjOwPgQ6WNJEZVQbOJtg_8wJE_mldThWxidPeF8yaSQ_hd.png',
  title: 'BONUS #4: Biblioteca de Manuales PDF',
  desc: 'Diagramas técnicos de marcas líderes.',
  price: '$25.000'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/eH2nPKXXZswtcPDmhvLhhp/5-bono-5-la-boveda-tecnica-pack-definiti_mqr16J_lQfeHLGCqJ3h-sw_TBqObNOsR_u8yHWymQAgGw_hd.png',
  title: 'BONUS #5: La Bóveda Técnica',
  desc: 'Pack definitivo de diagramas y planos nivel profesional.',
  price: '$19.990'
}];
export function BonusCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleScroll = () => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll > 0) {
        setScrollProgress(el.scrollLeft / maxScroll);
      }
    };
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full" data-id="element-1">
      <style data-id="element-2">{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }
      `}</style>

      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-6 px-4 md:px-0 hide-scrollbar" data-id="element-3">
        {BONUS_ITEMS.map((bonus, idx) => <div key={idx} className="snap-center shrink-0 w-[85vw] max-w-[340px] md:w-[350px] md:max-w-none" data-id="element-4">
            <Card className="h-full flex flex-col overflow-hidden border-slate-700 bg-slate-800/50" data-id="element-5">
              <div className="aspect-[9/16] bg-slate-900 relative" data-id="element-6">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-7" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4" data-id="element-8">
                  <p className="text-slate-400 text-sm line-through decoration-red-500" data-id="element-9">
                    {bonus.price}
                  </p>
                  <p className="text-green-400 font-bold text-sm" data-id="element-10">
                    HOY: GRATIS
                  </p>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-11">
                <h3 className="font-bold text-white mb-1" data-id="element-12">{bonus.title}</h3>
                <p className="text-sm text-slate-400" data-id="element-13">{bonus.desc}</p>
              </div>
            </Card>
          </div>)}
      </div>

      {/* Neon blue progress bar */}
      <div className="mx-4 md:mx-0 mt-2" data-id="element-14">
        <div className="h-1 bg-slate-800 rounded-full overflow-hidden" data-id="element-15">
          <div className="h-full bg-blue-500 rounded-full transition-all duration-150 shadow-[0_0_8px_rgba(59,130,246,0.6)]" style={{
          width: `${Math.max(20, scrollProgress * 100)}%`
        }} data-id="element-16" />
        </div>
      </div>

      <p className="text-center text-slate-500 text-sm mt-3 animate-pulse" data-id="element-17">
        👉 Deslizá para ver todos los bonos 👈
      </p>
    </div>;
}